var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddEnclosed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.367,
    height: 18.367,
    viewBox: "0 0 18.367 18.367",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Add-_enclosed",
    "data-name": "Add- enclosed",
    transform: "translate(-79.112 -404.556)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "add_circle_FILL1_wght400_GRAD0_opsz48",
    d: "M12.564,17.775h1.378V13.964h3.834V12.587H13.941V8.592H12.564v3.995H8.592v1.378h3.972Zm.62,4.592a8.886,8.886,0,0,1-3.559-.723,9.252,9.252,0,0,1-4.9-4.9,9.173,9.173,0,0,1,0-7.14A9.178,9.178,0,0,1,6.7,6.686,9.414,9.414,0,0,1,9.625,4.723a9.173,9.173,0,0,1,7.14,0A9.169,9.169,0,0,1,21.644,9.6a9.173,9.173,0,0,1,0,7.14,9.414,9.414,0,0,1-1.963,2.927,9.178,9.178,0,0,1-2.916,1.974A8.942,8.942,0,0,1,13.183,22.367Z",
    transform: "translate(75.112 400.556)",
    fill: "#005ca3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddEnclosed);
export default __webpack_public_path__ + "static/media/add_enclosed.0e4de23d29795ee01591274106b93d13.svg";
export { ForwardRef as ReactComponent };